module.exports = __webpack_public_path__ + "static/media/lens_ns.7d37dd84.png";